/**
 * SupervisorDashboardPage - Supervisor operations dashboard
 *
 * Wrapper page for the SupervisorDashboard component that provides
 * team oversight, task assignment monitoring, and operational metrics.
 *
 * Route: /dashboards/supervisor
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconUsersGroup } from '@tabler/icons-react';

import { SupervisorDashboard } from './SupervisorDashboard';
import { useAuth } from '@/auth/AuthContext';

export function SupervisorDashboardPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="blue">
            <IconUsersGroup size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Supervisor Dashboard</Title>
            <Text size="sm" c="dimmed">
              Team oversight, task assignment monitoring, and operational metrics
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <SupervisorDashboard />
    </Container>
  );
}

export default SupervisorDashboardPage;
